const extractColorFromHex = (hexColor, bit) => {
  if (hexColor.length === 4) {
    return `0x${hexColor[bit]}${hexColor[bit]}`;
  }

  if (hexColor.length === 7) {
    return `0x${hexColor[bit * 2 - 1]}${hexColor[bit * 2]}`;
  }

  return 0;
};

const hexToRgbArr = (hexColor) => [
  +extractColorFromHex(hexColor, 1),
  +extractColorFromHex(hexColor, 2),
  +extractColorFromHex(hexColor, 3),
];

const rgbArrToHex = (rgbArr) => {
  const hexCode = rgbArr.map((x) => {
    const hex = x.toString(16);
    return hex.length === 1
      ? `0${hex}`
      : hex;
  }).join('');

  return `#${hexCode}`;
};

const shadeColor = (hexColor, shadeFunction) => {
  const rgbArr = hexToRgbArr(hexColor).map((rgb) => shadeFunction(rgb));
  return rgbArrToHex(rgbArr);
};

const darkenColor = (hexColor, ratio) => shadeColor(hexColor, (rgb) => Math.floor(rgb - ratio * rgb));

const lightenColor = (hexColor, ratio) => shadeColor(hexColor, (rgb) => Math.ceil(rgb + ratio * (255 - rgb)));

export {
  hexToRgbArr,
  rgbArrToHex,
  darkenColor,
  lightenColor,
};
